<div fxLayout="column">
  <app-page-header [section]="'Contacts'"
                   [title]="'Manage your retailer information'"
                   [description]="'The retailers module allows you to see all the relevant retailer information. This information automatically updates across all other functionalities as the retailer makes changes.'"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

    <div fxFlexOffset="20px">
      <div fxLayout="row">
        <span class="subtitle-default">Retailer List</span>
        <button class="button-action" mat-flat-button fxFlexOffset="50px"
                (click)="openCreateRetailer()"
                [disabled]="loader.loading$ | async">
          <div class="button-text">Create a contact</div>
        </button>
      </div>
    </div>

    <div class="mat-elevation-z3 radius-10" fxLayout="column" fxFlexOffset="30px">
      <app-crud-table
        (rowSelected)="retailerSelectedForView($event)"
        [loading$]="loader.loading$"
        [modelType]="CrudRetailer"
        [subTitle]="'View All Retailer Information'"
        [tableData]="crudTableData"
        [title]="'Retailer Information'"
      >
      </app-crud-table>
    </div>
  </div>

</div>
